import styled from "styled-components";

export const RegisterStyle=styled.div`
.register-container {
        background-Color:white;
        width:45vh;
        border-radius:10px;
        display: flex;
        flex-direction:column;
        padding:20px 20px 40px 20px;
        align-self:center;
        box-shadow: 0 0 30px rgba(247, 148, 29, 0.3); /* Add a box shadow */
        z-index: 1; /* Add a higher z-index to make the shadow visible */
    }
    .body{
        background-Color:hsl(30, 2%, 21%);
        display: flex;
        flex-direction:column;
        height: 100vh;
        width:100%;

    }

    .back-icon{
        color:white;
        font-size:25px;
        cursor: pointer;
        margin:20px 10px 10px 20px;
        font-family: "Inter var", sans-serif;
    }

    .container2{
        display:flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
    }

    .app-logo{
        width:25vh;
        height:7vh;
        align-self:center;
        margin-bottom:10px;
    }

    .input-field{
        width:32vh;
        height:4vh;
        margin-bottom:1px;
        font-family: "Inter var", sans-serif;
        :focus{
            border-color:white;
            box-shadow: 0 0 5px #f7951d;
        }
    }
    .form-text{
        font-size:13px;
        font-weight:700;
        color:black;
        font-family: "Inter var", sans-serif;
    }

    .form-button{
        align-self:center;
        width:32vh;
        background-color:hsl(33, 93%, 54%);
        border-color:white;
        margin-top:40px;
        color:white;
        font-family: "Inter var", sans-serif;
    }

    .form-container{
        align-self:center;
        margin-top:40px;
    }

    .description{
        font-weight: 800;
        font-size: 1.3em;
        margin-top: 0.5em;
        color:black;
        font-family: "Inter var", sans-serif;
        align-self:center;
    }

    
    .text-error2{
        font-family: "Inter var", sans-serif;
        color:red;
        font-size:13px;
        text-align:center;
        margin-top:10px;
    }
`